import { getCookie } from "./storage";
import { SESSION_COOKIE_NAME } from "./settings";
import jwt_decode from "jwt-decode";

export function getStatusColor(percentage: number): string {
  if (percentage >= 70) {
    return "#00A9E0";
  } else if (percentage >= 30) {
    return "#FFCC00";
  } else {
    return "#FF3B30";
  }
}

export function getSession(): any | null {
  const sessionCookie = getCookie(SESSION_COOKIE_NAME);

  if (sessionCookie) {
    return JSON.parse(sessionCookie);
  } else {
    return null;
  }
}

export function isSupportSession(): boolean {
  const session = getSession();
  let isSupportSession: boolean = false;
  let decodedToken: any;

  if (session) {
    decodedToken = jwt_decode(session.jwToken);
    isSupportSession = decodedToken.isSupportMode === "True";
  }

  return isSupportSession;
}

export function getSessionLanguage(): string {
  const session = getSession();
  if (session) {
    return session.culture;
  }

  return "";
}

export function scrollElementLeft(
  _element: string,
  _width: number = 300
): number {
  if (!_element)
    throw "scrollElementLeft error. Can not do left scroll on undefined element.";

  const content = $(_element);
  if (!content)
    throw "scrollElementLeft error. Can not find element " + _element + ".";

  const leftPos: number = content.scrollLeft() ?? 0;
  content.animate({ scrollLeft: leftPos - _width }, 800);
  return leftPos + _width;
}

export function scrollElementRight(
  _element: any,
  _width: number = 300
): number {
  if (!_element)
    throw "scrollElementRight error. Can not do left scroll on undefined element.";

  const content = $(_element);
  if (!content)
    throw "scrollElementRight error. Can not find element " + _element + ".";

  const leftPos: number = content.scrollLeft() ?? 0;
  content.animate({ scrollLeft: leftPos + _width }, 800);
  return leftPos + _width;
}

export function textNormalize(text: string): string {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
